import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { ScreenHelper } from "../../../common/helpers/screenHelper";

@Component({
    selector: 'auth-layout',
    templateUrl: './authLayout.component.html',
    styleUrls: ['../../../../theme/css/auth.css'],
    moduleId: module.id.toString(),
    encapsulation: ViewEncapsulation.None,
    host: {
        '(window:resize)': 'onResize($event)'
    }
})
export class AuthLayoutComponent implements OnInit, AfterViewInit {
    public isMobileMenu: boolean;
    public loading: boolean = false;
    private sidebarVisible: boolean;

    constructor(private element: ElementRef, private router: Router, private renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.sidebarVisible = false;
        this.isMobileMenu = ScreenHelper.isTabletOrPhone();

        this.router.events.subscribe(val => {
            if(val instanceof NavigationStart)
                this.loading = true;
            else if(val instanceof NavigationEnd)
                this.loading = false;
        });
    }

    ngAfterViewInit(): void {
        let spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    }

    public onResize(event: any): void {
        this.isMobileMenu = ScreenHelper.isTabletOrPhone();
    }
}


// WEBPACK FOOTER //
// ./app/components/auth/authLayout/authLayout.component.ts